export default __webpack_public_path__ + "static/media/artist-img5.5c1e11a3.jpg";